import { useEffect, useState } from "react";
import Address from "../../../components/Address";
import { AdminMenuBar } from "../../../components/admin/AdminMenuBar";
import HistoryCard from "./HistoryCard";
import HistoryCardWithYear from "./HistoryCardWithYear";
import {
    getCompanyHistory,
    insertCompanyHistory,
    getStandardYearList,
    insertStandardYear,
    deleteStandardYear,
} from "../../../services/CompanyHistoryAPI";
import { Input, Button, FormControl, Stack, useDisclosure, Textarea } from "@chakra-ui/react";
import { checkSession } from "../../../services/Admin";

export const AdminCompanyHistory = () => {
    const [historyCards, setHistoryCards] = useState([]);

    const [year, setYear] = useState();
    const [content, setContent] = useState();

    const [isYearValid, setIsYearValid] = useState(true);
    const [isContentValid, setIsContentValid] = useState(true);

    const [standardYear, setStandardYear] = useState();
    const [isStandardYearValid, setIsStandardYearValid] = useState(true);

    const [standardYearList, setStandardYearList] = useState([]);

    const deletionAlert = useDisclosure();

    const setCompanyHistoryCards = (historys, startYearIndex) => {
        let cards = [];
        let startYear = standardYearList[startYearIndex].standardYear;
        let endYear =
            startYearIndex == standardYearList.length - 1 ? 0 : standardYearList[startYearIndex + 1].standardYear;

        historys.map((history, index) => {
            if (history.year < startYear && history.year >= endYear) {
                cards.push(
                    <HistoryCard
                        key={history.id}
                        history={history}
                        setHistoryCards={setHistoryCards}
                        updateCompanyHistoryCards={updateCompanyHistoryCards}
                    />
                );
            }
        });

        return { year: standardYearList[startYearIndex].standardYear, cards: cards };
    };

    const setCompanyHistoryCardsWithYear = (historys) => {
        let historyCards = [];

        standardYearList.map((year, index) => {
            historyCards.push(setCompanyHistoryCards(historys, index));
        });

        setHistoryCards(historyCards);
    };

    const updateCompanyHistoryCards = () => {
        getCompanyHistory().then((result) => {
            setCompanyHistoryCardsWithYear(result);
        });
    };

    const updateStandardYearList = async () => {
        let yearList = [{ id: null, standardYear: new Date().getFullYear() }];

        getStandardYearList().then((result) => {
            result.map((year, index) => {
                yearList.push({ id: year.id, standardYear: year.standardYear });
            });
            setStandardYearList(yearList);
        });
    };

    const deleteStandard = (year) => {
        deleteStandardYear(year).then(() => {
            updateStandardYearList();
        });
        deletionAlert.onClose();
    };

    useEffect(() => {
        checkSession();
        updateStandardYearList();
    }, []);

    useEffect(() => {
        updateCompanyHistoryCards();
    }, [standardYearList]);

    const isHistoryInputComplete = () => {
        let isIputHistory = true;

        if (year == null || year == "") {
            //연도 입력 검사
            setIsYearValid(false);
            isIputHistory = false;
        } else {
            setIsYearValid(true);
        }

        if (content == null || content == "") {
            //내용 입력 검사
            setIsContentValid(false);
            isIputHistory = false;
        } else {
            setIsContentValid(true);
        }

        return isIputHistory;
    };

    const insertHistory = () => {
        if (isHistoryInputComplete() == false) {
            //연도 및 내용 모두 입력시에만 데이터 저장\
            return;
        }

        const history = { year: year, content: content };

        insertCompanyHistory(history)
            .then((Resopnse) => {
                updateCompanyHistoryCards();
            })
            .catch((ex) => {
                alert("서버에 이상이 있습니다. 관리자에게 문의주세요");
            });
    };

    const getHistoryCardWithYear = () => {
        let historyCardsWithYear = [];

        {
            historyCards.map((historyCard, index) => {
                historyCardsWithYear.push(
                    <HistoryCardWithYear key={index} historyCard={historyCard} deleteStandard={deleteStandard} />
                );
            });
        }

        return historyCardsWithYear;
    };

    const insertYear = () => {
        if (isYearCorrect(standardYear)) {
            //4자리 숫자 입력시에만 저장
            insertStandardYear(standardYear).then(() => {
                updateStandardYearList();
            });
            return;
        }

        setIsStandardYearValid(false);
    };

    const isYearCorrect = (year) => {
        const yearRegex = /^(\d{4})$/;
        return yearRegex.test(year);
    };

    const isYearInput = (year) => {
        const yearRegex = /^(\d{0,4})$/;
        return yearRegex.test(year);
    };

    return (
        <div className="main_container">
            <AdminMenuBar selected_page={1} />
            <div className="common_frame_container">
                <div className="common_content_container">
                    <div className="pl-[20px] text-4xl my-[20px]">연도 기준 추가</div>
                    <FormControl mb="20px" pl="20px">
                        <Stack direction="row" spacing={2}>
                            <Input
                                w="15%"
                                py={10}
                                fontSize="4xl"
                                placeholder="연도"
                                type="number"
                                value={standardYear || ""}
                                onChange={(event) => {
                                    let year = event.target.value;
                                    if (isYearInput(year)) {
                                        setStandardYear(year);
                                    }
                                }}
                                isInvalid={!isStandardYearValid}
                                errorBorderColor="crimson"
                            />
                            <Button
                                colorScheme="teal"
                                variant="outline"
                                py={10}
                                fontSize="4xl"
                                w="10%"
                                onClick={insertYear}
                            >
                                추가
                            </Button>
                        </Stack>
                    </FormControl>

                    <div className="pl-[20px] text-4xl my-[20px]">내용 추가</div>
                    <FormControl mb="20px" pl="20px">
                        <Stack direction="row" spacing={3}>
                            <Input
                                w="15%"
                                py={10}
                                fontSize="4xl"
                                placeholder="연도"
                                type="number"
                                value={year}
                                onChange={(event) => {
                                    let year = event.target.value;
                                    if (isYearInput(year)) {
                                        setYear(year);
                                    }
                                }}
                                isInvalid={!isYearValid}
                                errorBorderColor="crimson"
                            />
                            <Textarea
                                py="10px"
                                w="75%"
                                fontSize="4xl"
                                placeholder="내용"
                                value={content}
                                onChange={(event) => setContent(event.target.value)}
                                isInvalid={!isContentValid}
                                errorBorderColor="crimson"
                            />
                            <Button
                                colorScheme="teal"
                                variant="outline"
                                py={10}
                                fontSize="4xl"
                                w="10%"
                                onClick={insertHistory}
                            >
                                추가
                            </Button>
                        </Stack>
                    </FormControl>

                    <div style={{ width: "100%", height: "100px" }}></div>
                    <span className="content_title">회사연혁</span>
                    <div className="title_line" style={{ width: "140px", height: "3px" }}></div>

                    {getHistoryCardWithYear()}

                    <div style={{ width: "100%", height: "100px" }}></div>
                </div>
            </div>

            <Address />
        </div>
    );
};
